module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fb-Gb-Hc-Ia-Ge.6662ce81.png";